// extracted by mini-css-extract-plugin
export default {"benefits":"styles_benefits__87jX-","fourBenefits":"styles_fourBenefits__vcthv","carWithCta":"styles_carWithCta__8y5hz"};